export function videoSetupUrlFromData(dataEl) {
    if (!dataEl || !dataEl.dataset) return null;
    if (dataEl.dataset.videoSetupUrl) return dataEl.dataset.videoSetupUrl;

    const showId = dataEl.dataset.showId;
    const youtubeEpisodeId = dataEl.dataset.youtubeEpisodeId;
    if (!showId || !youtubeEpisodeId) return null;

    return `/shows/${showId}/episodes/${youtubeEpisodeId}/edit-youtube?continue_to_audio=true`;
}

export function navigateToVideoSetup(dataEl, location = window.location) {
    const url = videoSetupUrlFromData(dataEl);
    if (!url) return false;

    location.href = url;
    return true;
}

if (typeof window !== "undefined") {
    window.CohostVideoSetupNavigation = {
        videoSetupUrlFromData,
        navigateToVideoSetup,
    };
}
